/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateSiteResponseData,
  CreateSiteResponseDataFromJSON,
  CreateSiteResponseDataFromJSONTyped,
  CreateSiteResponseDataToJSON
} from './CreateSiteResponseData'

/**
 *
 * @export
 * @interface CreateSiteResponse
 */
export interface CreateSiteResponse {
  /**
   *
   * @type {number}
   * @memberof CreateSiteResponse
   */
  status: number
  /**
   *
   * @type {CreateSiteResponseData}
   * @memberof CreateSiteResponse
   */
  data: CreateSiteResponseData
}

export function CreateSiteResponseFromJSON(json: any): CreateSiteResponse {
  return CreateSiteResponseFromJSONTyped(json, false)
}

export function CreateSiteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSiteResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: CreateSiteResponseDataFromJSON(json['data'])
  }
}

export function CreateSiteResponseToJSON(value?: CreateSiteResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateSiteResponseDataToJSON(value.data)
  }
}
